import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 32px;
  height: 100%;
  padding-bottom: 64px;

  & > :first-child {
    margin-bottom: 0 !important;
  }
`;
